// extracted by mini-css-extract-plugin
export default {"wrap":"GJ-z","heading":"HJ-z","brandPromo":"IJ-z"};